import useABTest from "@/utils/hooks/useABtest";

export function usePinActionAb() {
  return useABTest("pinActionAb", "old", {
    new: "new",
    old: "old",
  });
}
